import LexSharesPortfolio from './LexSharesPortfolio'

export default LexSharesPortfolio
